import { createSlice } from '@reduxjs/toolkit';
import { mergeNationCode } from 'utils/common';

const employeeInformationSlice = createSlice({
  name: 'employeeInformation',
  initialState: {
    emp: {},
    serviceDesk: null,
    isSuccess: false,
    countryList: {},
    termsContentList: {},
    termsAgreementList: {},
    trmsCd: null,
    termsVersion: {},
    termsContent: {},
    serviceList: [],
    quickLinkDomain: {
      meeting: null,
      drive: null,
    },
    companyPolicy: {},
    cookieSavedYn: false,
  },
  reducers: {
    getReadEmployeeInfo: () => {},
    getReadEmployeeInfoSuccess: (state, { payload }) => {
      const mergeNationCodeList = mergeNationCode(payload.nationCodeList);
      state.emp = payload;
      state.emp.nationCodeList = mergeNationCodeList;
    },
    modifyEmployeeInfo: () => {},
    modifyEmployeeInfoSuccess: (state, { payload }) => {
      state.isSuccess = payload;
    },
    getSupportList: () => {},
    getSupportListSuccess: (state, { payload }) => {
      state.serviceDesk = payload;
    },
    setIsSuccess: state => {
      state.isSuccess = false;
    },
    getCountryList: () => {},
    getCountryListSuccess: (state, { payload }) => {
      state.countryList = payload;
    },
    getTermsContentList: () => {},
    getTermsContentListSuccess: (state, { payload }) => {
      state.termsContentList = payload;
    },
    getTermsAgreementList: () => {},
    getTermsAgreementListSuccess: (state, { payload }) => {
      state.termsAgreementList = payload;
    },
    getTermsAgreementListFail: state => {
      state.termsAgreementList = {};
    },
    setTrmsCd: (state, { payload }) => {
      state.trmsCd = payload;
    },
    setTermsInit: state => {
      state.termsVersion = {};
      state.termsContent = {};
    },
    getTermsVersion: () => {},
    getTermsVersionSuccess: (state, { payload }) => {
      const _trmsVerVals = payload.trmsVerVals?.length > 0 ? payload.trmsVerVals.reverse() : [];
      state.termsVersion = { ...payload, trmsVerVals: _trmsVerVals };
    },
    getTermsContents: () => {},
    getTermsContentsSuccess: (state, { payload }) => {
      state.termsContent = payload;
    },
    getCookieSavedYn: () => {},
    getCookieSavedYnSuccess: (state, { payload }) => {
      state.cookieSavedYn = payload.COOKIESAVEDYN;
    },
    getServiceList: () => {},
    getServiceListSuccess: (state, { payload: serviceList }) => {
      state.serviceList = serviceList.SERVICECODE.split('|');
    },
    getServiceListFail: state => {
      state.serviceList = [];
    },
    getMeetingDomain: () => {},
    getMeetingDomainSuccess: (state, { payload }) => {
      state.quickLinkDomain.meeting = payload.value;
    },
    getMeetingDomainFail: state => {
      state.quickLinkDomain.meeting = null;
    },
    getDriveDomain: () => {},
    getDriveDomainSuccess: (state, { payload }) => {
      state.quickLinkDomain.drive = payload.url;
    },
    getDriveDomainFail: state => {
      state.quickLinkDomain.drive = null;
    },
    getCompanyPolicy: () => {},
    getCompanyPolicySuccess: (state, { payload }) => {
      state.companyPolicy = payload;
    },
    getCompanyPolicyFail: (state, { payload }) => {
      state.companyPolicy = {};
    },
  },
});

export const {
  getReadEmployeeInfo,
  getReadEmployeeInfoSuccess,
  modifyEmployeeInfo,
  modifyEmployeeInfoSuccess,
  getSupportList,
  getSupportListSuccess,
  setIsSuccess,
  getCountryList,
  getCountryListSuccess,
  getTermsContentList,
  getTermsContentListSuccess,
  getTermsAgreementList,
  getTermsAgreementListSuccess,
  getTermsAgreementListFail,
  setTrmsCd,
  setTermsInit,
  getTermsVersion,
  getTermsVersionSuccess,
  getTermsContents,
  getTermsContentsSuccess,
  getServiceList,
  getServiceListSuccess,
  getServiceListFail,
  getMeetingDomain,
  getMeetingDomainSuccess,
  getMeetingDomainFail,
  getDriveDomain,
  getDriveDomainSuccess,
  getDriveDomainFail,
  getCookieSavedYn,
  getCookieSavedYnSuccess,
  getCompanyPolicy,
  getCompanyPolicySuccess,
  getCompanyPolicyFail,
} = employeeInformationSlice.actions;
export default employeeInformationSlice.reducer;
